<template>
	<v-dialog
		v-model="dialog"
		max-width="960px"
		:fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
		:transition="$vuetify.breakpoint.mdAndDown ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="mt-4" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-plus</v-icon>
				製番を追加
			</v-btn>
		</template>

		<v-card tile>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">製番を追加</v-app-bar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pa-2">
				<v-row no-gutters class="mt-4">
					<v-text-field
						max-width="300px"
						v-model="q.matter_product_product_number_name_cont"
						label="製造番号"
						outlined
						dense
						class="mr-2"
						clearable
						hide-details
					/>
					<v-btn color="secondary" @click="fetchOrderIndividualInfos(q)">
						<v-icon class="mr-1">mdi-magnify</v-icon>
						検索
					</v-btn>
				</v-row>
				<v-divider class="mt-4" />
				<div class="table-container mt-4">
					<v-data-table
						locale="ja-JP"
						v-model="selectedInfos"
						show-select
						item-key="id"
						:items="order_individual_infos"
						:headers="headers"
						:mobile-breakpoint="240"
						hide-default-footer
						disable-filtering
						disable-pagination
						disable-sort
						no-data-text="データがありません。"
						@click:row="toggleSelectedInfo"
					/>
				</div>
				<PaginationModule :pagination="pagination" @get-page="getPage($event)"></PaginationModule>
			</v-sheet>
			<v-row no-gutters justify="center" class="py-4">
				<v-col sm="2" cols="0" />
				<v-col sm="8" cols="12" class="text-center">
					<v-btn color="secondary" @click="addOrderIndividualInfos">
						<v-icon class="mr-1">mdi-plus</v-icon>
						選択した製造番号を追加する
					</v-btn>
				</v-col>
				<v-col sm="2" cols="0" class="text-right">
					<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
				</v-col>
			</v-row>
		</v-card>
	</v-dialog>
</template>

<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import common from "../../../helper/common"
import PaginationModule from "../../../modules/PaginationModule.vue"

export default {
	props: {
		existing_order_individual_infos: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			common,
			dialog: false,
			order_individual_infos: [],
			selectedInfos: [],
			headers: [
				{ text: "製造番号", value: "product_number", width: "200px" },
				{ text: "製品名", value: "product_name", width: "200px" },
				{ text: "数量", value: "quantity", width: "80px" },
			],
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				sorts: "created_at desc",
				matter_product_product_number_name_cont: null,
				id_not_in: this.existing_order_individual_infos.map((o) => o.id),
			},
		}
	},
	components: {
		PaginationModule,
	},
	methods: {
		// TODO:
		fetchOrderIndividualInfos(q, page = 1) {
			const headers = authenticate.setHeader()
			const params = { page, q }
			axios
				.get("/erp/v1/required_times/order_individual_infos", {
					params,
					headers,
				})
				.then((res) => {
					this.order_individual_infos = res.data.order_individual_infos.map((o) => {
						// o.product_number = common.productNumberByOrderIndividualInfo(o)
						// o.product_name = o.matter_product ? common.productNameWithSubName(o.matter_product) : 'テスト製品'
						o.product_number = "2023XXXXX"
						o.product_name = "XXXXXXXXXX"
						return o
					})
					this.pagination = res.data.pagination
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		getPage(page) {
			this.fetchOrderIndividualInfos(this.q, page)
		},
		toggleSelectedInfo(info) {
			if (this.selectedInfos.includes(info)) {
				this.selectedInfos = this.selectedInfos.filter((i) => i.id !== info.id)
			} else {
				this.selectedInfos.push(info)
			}
		},
		addOrderIndividualInfos() {
			this.$emit("add-order-individual-infos", this.selectedInfos)
			this.selectedInfos = []
			this.dialog = false
		},
	},
	watch: {
		existing_order_individual_infos: {
			handler: function (val, oldVal) {
				this.q.id_not_in = val.map((o) => o.id)
			},
			deep: true,
		},
	},
}
</script>